var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg21(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 65.42 43.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".g{fill:#00322e;}.h{fill:#fff;filter:url(#b);}.i{filter:url(#e);}"), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "c",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.18
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "c",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "e",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "f",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "f",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M15.06,37.27l.4-2.34c1.42-8.27,6.24-12.26,11.56-15.05l-8.15-1.39,.21-1.88c.83-7.36,5.97-11.41,14.46-11.41,7.94,0,13.08,4.16,13.08,10.6,0,5.53-3.15,8.43-7.02,10.64h5.33l-1.97,10.84H15.06ZM33.27,15.99c-.22,0-.4,.04-.46,.09-.03,.03-.21,.24-.31,.98,.54-.36,.77-.65,.77-.95,0-.05,0-.09,0-.12Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("g", {
    className: "i"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M31.55,28.43h11l-1.24,6.84H17.43c1.32-7.72,5.72-11.36,12.16-14.44,3.88-1.88,5.68-2.68,5.68-4.72,0-1.32-.68-2.12-2-2.12-2.2,0-2.88,1.68-2.84,4.44l-9.36-1.6c.68-6.04,4.64-9.64,12.48-9.64,6.84,0,11.08,3.32,11.08,8.6,0,5.8-3.96,8.04-10,10.92-1.2,.6-2.24,1.16-3.08,1.72Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg21);
export default __webpack_public_path__ + "static/media/2_1.c8265d403df382c1abc8b1cb8f974f37.svg";
export { ForwardRef as ReactComponent };